export enum RejectReasonReasonEnum {
  NOT_QUALIFIED = 'NOT_QUALIFIED',
  OVERQUALIFIED = 'OVERQUALIFIED',
  POOR_FIT = 'POOR_FIT',
  BUDGET_CONSTRAINTS = 'BUDGET_CONSTRAINTS',
  POSITION_FILLED = 'POSITION_FILLED',
  OTHER = 'OTHER',
}
